/* src/app/modules/employees/tiempo/components/grupo-registros-tiempo/grupo-registros-tiempo.component.css */
mat-expansion-panel {
  margin-bottom: 16px !important;
}
.day-card {
  margin-bottom: 10px !important;
  position: relative;
}
.dia-menu-button {
  position: absolute;
  right: 8px;
  top: 8px;
}
.registro-content {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: flex-start;
  padding: 8px 0;
  flex-wrap: wrap;
}
.tiempo-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 120px;
  position: relative;
}
.geolocalizacion-icon {
  position: absolute;
  top: 0;
  right: 0;
  color: var(--cf-brand-dark);
  cursor: pointer;
  font-size: 18px;
  transition: all 0.2s ease;
}
.geolocalizacion-icon:hover {
  color: #b8790a;
  transform: scale(1.1);
}
.hora {
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
  white-space: nowrap;
}
.duracion {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.9em;
}
.estado-info {
  margin: 0 16px;
  flex-grow: 1;
}
.pausas-container {
  margin-top: 8px;
  width: 100%;
}
.pausa-panel {
  background: white;
}
.pausa-panel ::ng-deep .mat-expansion-panel-body {
  padding: 0 !important;
}
.pausa-panel ::ng-deep .mat-mdc-list {
  padding: 0;
}
.pausa-panel ::ng-deep .mat-mdc-list-item {
  height: auto !important;
  padding: 8px 16px;
}
.pausa-panel ::ng-deep .mat-mdc-list-item .mdc-list-item__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start !important;
  padding: 8px 0 !important;
}
.pausa-info {
  display: flex;
  flex: 1;
  justify-content: flex-start;
  align-items: flex-start;
  column-gap: 20px;
}
.pausa-duracion,
.pausa-minutos {
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 4px;
}
.pausa-motivo {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.9em;
}
.registro-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  height: auto !important;
}
.registro-item:last-child {
  border-bottom: none;
}
.registro-menu-button .mat-icon {
  color: black !important;
}
mat-expansion-panel {
  margin-bottom: 16px;
}
::ng-deep .mat-expansion-panel-body {
  padding: 16px !important;
}
::ng-deep .mat-mdc-list-item,
::ng-deep .mat-mdc-list-item .mdc-list-item__content {
  height: auto !important;
}
.panel-title {
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.panel-description {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.panel-actions {
  display: flex;
  gap: 8px;
  margin-left: auto;
}
.panel-actions button {
  opacity: 0.8;
  transition: opacity 0.2s;
}
.panel-actions button:hover {
  opacity: 1;
}
::ng-deep .mat-expansion-panel-header-description {
  justify-content: space-between;
  align-items: center;
  margin-right: 0;
}
.fecha-range-card {
  margin: 16px 0;
  background-color: #f5f5f5;
}
.fecha-range-form {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  flex-wrap: wrap;
}
.fecha-range-form mat-form-field {
  flex: 1;
  min-width: 200px;
}
.fecha-range-form button {
  margin-top: 3px;
}
@media (max-width: 600px) {
  .fecha-range-form {
    flex-direction: column;
  }
  .fecha-range-form mat-form-field {
    width: 100%;
  }
  .fecha-range-form button {
    width: 100%;
  }
}
/*# sourceMappingURL=grupo-registros-tiempo.component.css.map */
